import React from 'react';

import { SxProps, Theme, Typography } from '@mui/material';

import { GuideAccordionList } from './GuideAccordionList';

export type GuideFaqItem = Readonly<{
  id: string;
  question: string;
  answer: string;
}>;

type GuideFaqSectionProps = Readonly<{
  idPrefix: string;
  questions: readonly GuideFaqItem[];
}>;

export const GuideFaqSection: React.FC<GuideFaqSectionProps> = ({ idPrefix, questions }) => (
  <GuideAccordionList
    idPrefix={idPrefix}
    items={questions.map((q) => ({
      id: q.id,
      title: q.question,
      details: (
        <Typography variant="text-md-regular" sx={answerSx}>
          {q.answer}
        </Typography>
      ),
    }))}
  />
);

const answerSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-tertiary'],
});
